import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type StoreBaseReturn } from '@shared/api';

interface UseApproveCreditLimitStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  approveCreditLimit: (applicationId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useApproveCreditLimitStore = create<UseApproveCreditLimitStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  approveCreditLimit: async (applicationId, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.approveCreditLimit(applicationId, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
